/**
 * 医疗相关的过滤器
 */

/**
 * @description 咨询单状态
 *
 */
var statusMap = {
  'init': '新建',
  'following': '跟进中',
  'completed': '处理完成'
};
export function medicalSheetStatusFilter(status) {
  return statusMap[status];
}
export function getMedicalSheetStatus(label) {
  return Object.keys(statusMap).find(function (key) {
    return statusMap[key] === label;
  });
}